<script setup>
import { THERAPISTS } from "@/content/therapists";
import ContentCard from "@/app/components/common/ContentCard.vue";
import { ref } from "vue";

/* eslint-disable no-undef */
defineProps({
  noBox: {
    type: Boolean,
    default: false,
  },
});

const therapist = THERAPISTS[0];
const showImage = ref(true);
</script>

<template>
  <section class="section section-with-divider">
    <h2>Über mich</h2>

    <img
      v-if="showImage"
      :src="therapist.image"
      :alt="therapist.name"
      @error="showImage = false"
      class="therapist-image"
    />

    <ContentCard
      subheading="Meine Ausbildungen und Qualifikationen"
      :no-box="noBox"
    >
      <template v-slot:description>
        <p>
          Als Heilpraktikerin für Psychotherapie verfüge ich über fundierte
          Ausbildungen und langjährige praktische Erfahrung in verschiedenen
          therapeutischen Methoden. Mein Ansatz basiert auf wissenschaftlich
          fundierten Verfahren, die ich individuell auf Ihre Bedürfnisse
          abstimme.
        </p>
        <p>
          Zusätzlich bringe ich verschiedene Perspektiven aus meiner
          langjährigen Erfahrung in der Wirtschaft und als Mediatorin mit ein.
          Mir ist bewusst, dass Vielseitigkeit eine wichtige Haltung in diesem
          Beruf ist.
        </p>
      </template>
      <ul class="info-list">
        <li
          v-for="qualification in therapist.qualifications"
          :key="qualification"
        >
          {{ qualification }}
        </li>
      </ul>
    </ContentCard>
  </section>
</template>

<style scoped>
.section h2 {
  text-align: left;
  font-size: var(--font-size-xxl);
  color: var(--color-cream);
  font-weight: var(--font-weight-medium);
  letter-spacing: var(--letter-spacing-normal);
  margin: 0 0 var(--spacing-sm) 0;
}

.therapist-image {
  max-width: 320px;
  width: 100%;
  height: auto;
  border-radius: var(--box-border-radius);
  display: block;

  transition: transform var(--transition-normal),
    box-shadow var(--transition-normal);
}

.therapist-image:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
  transition: transform var(--transition-normal),
    box-shadow var(--transition-normal);
}

.info-list li::before {
  content: "✓";
  color: var(--color-cream-dark);
}

@media (min-width: 1024px) {
  .section {
    display: grid;
    grid-template-columns: auto 1fr;
  }

  .section h2 {
    grid-column: 1 / -1;
  }

  .therapist-image {
    max-width: 280px;
  }

  .section :deep(.content-card) {
    margin-top: 0;
    padding-top: 0;
  }
}

@media (max-width: 768px) {
  .therapist-image {
    max-width: 280px;
  }
}

@media (max-width: 480px) {
  .therapist-image {
    max-width: 240px;
    align-self: center;
  }
}
</style>
